import { useAuth0 } from '@auth0/auth0-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { PrimaryButton } from '../'
import { Logo } from '../icons'
import { LoadingRows } from '../ui'

export function Login(): JSX.Element {
    const { loginWithRedirect, isLoading } = useAuth0()
    const { t } = useTranslation()
    return (
        <div className='min-h-screen flex items-center justify-center bg-gray-50 px-4'>
            <div className='w-full max-w-sm bg-white border border-gray-200 rounded-xl shadow-sm p-8 text-center'>
                <div className='flex justify-center text-indigo-600'>
                    <Logo size={56} />
                </div>
                <h1 className='mt-5 text-xl font-bold text-gray-800'>{t('login.brand')}</h1>
                <p className='mt-1 text-sm text-gray-400'>{t('login.subtitle')}</p>
                <div className='mt-8'>
                    {isLoading
                        ? <LoadingRows message={t('login.loading')} />
                        : <PrimaryButton className='w-full' onClick={() => loginWithRedirect()}>{t('login.button.login')}</PrimaryButton>}
                </div>
            </div>
        </div>
    )
}
